<template>
    <SectionBase v-if="inProgressItems.length" class="InProgressSection" :title="$t('title')">
        <template v-slot:titleExtra>
            <div class="info">
                {{ inProgressItems.length }}
            </div>
        </template>

        <template v-slot:items>
            <template v-for="item of inProgressItems">
                <CoursePreview v-if="item.type === 'course'" :key="item.courseId" v-bind="item" />
                <VideoPreview v-else-if="item.type === 'video'" :key="item.videoId" :video-id="item.videoId" />
            </template>
        </template>
    </SectionBase>
</template>

<translations>
  title: 'In progress'
  title_no: 'Fortsett'
</translations>

<script>
import SectionBase from './SectionBase';
import CoursePreview from './CoursePreview';
import VideoPreview from './VideoPreview';

export default {
    components: { SectionBase, CoursePreview, VideoPreview },
    computed: {
        inProgressItems() {
            return this.$store.getters['moduleApp/inProgressItems'];
        }
    },
    mounted() {
        this.$store.dispatch('moduleApp/loadVideosInProgress');
    }
};
</script>

<style lang="scss" scoped>
.info {
    color: rgba(white, 0.5);
    margin-left: 1em;
}
</style>
